<template>
  <div class="tz-acknowledge">
    <div class="tz-acknowledge__wrapper">
      <p class="tz-acknowledge__cta-text" v-if="ctaText">{{ ctaText }}</p>
      <slot name="cta-text"></slot>
      <template v-if="checkboxList">
        <label
          class="tz-acknowledge__label"
          :key="`checkbox_${index}`"
          v-for="(checkbox, index) in checkboxArray"
        >
          <input
            type="checkbox"
            v-model="checkbox.isChecked"
            class="tz-acknowledge__checkbox"
          />
          <TzMarkdown :content="checkbox.checkboxText" />
        </label>
      </template>
      <label v-else class="tz-acknowledge__label">
        <input
          type="checkbox"
          v-model="isCheckboxChecked"
          class="tz-acknowledge__checkbox"
        />
        <TzMarkdown :content="checkboxText" />
      </label>
    </div>
    <button
      class="tz-acknowledge__button"
      :disabled="enableButton ? false : isButtonDisabled"
      @click.prevent="handleButtonClick"
    >
      {{ buttonText }}
      <img
        v-if="buttonIcon"
        :src="buttonIcon"
        alt=""
        :aria-hidden="true"
        class="tz-acknowledge__button-icon"
      />
    </button>
  </div>
</template>

<script>
import TzMarkdown from '@trazi/tz-markdown/src/tz-markdown.vue';

export default {
  name: 'TzAcknowledge',
  components: {
    TzMarkdown
  },
  data: function() {
    return {
      isButtonDisabled: true,
      checkboxArray: this.checkboxList,
      singleCheckboxChecked: this.isChecked
    };
  },
  computed: {
    isCheckboxChecked: {
      get: function() {
        return this.singleCheckboxChecked;
      },
      set: function(value) {
        this.setButtonDisabled();
        this.singleCheckboxChecked = value;
        this.$emit('tz-acknowledge-checkbox-change', value);
      }
    }
  },
  watch: {
    $data: {
      handler: function() {
        this.setButtonDisabled();
      },
      deep: true
    }
  },
  created() {
    this.setButtonDisabled();
  },
  props: {
    /**
     * Call to action text that will display above the checkboxes
     */
    ctaText: {
      type: String
    },
    /**
     * This is used if only a single checkbox is need to display on the page
     */
    checkboxText: {
      type: String
    },
    /**
     * Checks whether a checkbox has been checked
     */
    isChecked: {
      type: Boolean,
      default: false
    },
    /**
     * Is used if all checkboxes are required and disables the button
     */
    isRequired: {
      type: Boolean
    },
    /**
     * Used if more than on checkbox needs to be displayed on the page
     */
    checkboxList: {
      type: Array
    },
    /**
     * Text that will display inside the button
     */
    buttonText: {
      type: String,
      required: true
    },
    /**
     * Icon that
     */
    buttonIcon: {
      type: String,
      default: null
    },
    /**
     * Overwrites the default behaviour for the button
     */
    enableButton: {
      type: Boolean
    }
  },
  methods: {
    handleButtonClick() {
      this.$emit('tz-acknowledge-submit');
    },
    areCheckboxesChecked() {
      return (
        this.checkboxArray &&
        this.checkboxArray
          .filter(checkbox => checkbox.isRequired)
          .every(checkbox => checkbox.isChecked)
      );
    },
    setButtonDisabled() {
      this.isButtonDisabled = this.checkboxArray
        ? !this.areCheckboxesChecked()
        : this.isRequired && !this.isCheckboxChecked;
    }
  }
};
</script>
